// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./montserrat-bold.woff");
var ___CSS_LOADER_URL_IMPORT_1___ = require("./montserrat-normal.woff");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Montserrat';
  font-weight: 700;
  font-style: normal;

  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
}

@font-face {
  font-family: 'Montserrat';
  font-weight: 400;
  font-style: normal;

  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
}
`, "",{"version":3,"sources":["webpack://./src/fonts/fonts.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;;EAElB,kBAAkB;EAClB,2DAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;;EAElB,kBAAkB;EAClB,2DAAmD;AACrD","sourcesContent":["@font-face {\n  font-family: 'Montserrat';\n  font-weight: 700;\n  font-style: normal;\n\n  font-display: swap;\n  src: url('./montserrat-bold.woff') format('woff');\n}\n\n@font-face {\n  font-family: 'Montserrat';\n  font-weight: 400;\n  font-style: normal;\n\n  font-display: swap;\n  src: url('./montserrat-normal.woff') format('woff');\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
